import { ArrowRight, DollarSign, Briefcase, Users } from "lucide-react"
import { Button } from "~/components/ui/button"
import { Card, CardContent } from "~/components/ui/card"
import type { JobDetail } from "~/components/company/job_listings/mock-data"

type Props = {
  job: Pick<JobDetail, "id" | "hours" | "contract" | "salary">
}

export function JobContractSidebar({ job }: Props) {
  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="p-6 space-y-4">
          <h3 className="font-semibold text-gray-900">Contract Details</h3>
          <div className="space-y-3 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <Users className="h-4 w-4 text-primary" />
              <span>{job.hours}</span>
            </div>
            <div className="flex items-center gap-2">
              <Briefcase className="h-4 w-4 text-primary" />
              <span>{job.contract}</span>
            </div>
            <div className="flex items-center gap-2">
              <DollarSign className="h-4 w-4 text-primary" />
              <span>{job.salary}</span>
            </div>
          </div>
          <a href={`/job_listings/${job.id}/apply`} className="block pt-2">
            <Button className="w-full bg-primary hover:bg-primary/90 text-white">
              Apply Now
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </a>
        </CardContent>
      </Card>
    </div>
  )
}
